import { Button, useTheme, Box } from "@mui/material";
import { tokens } from "../../theme";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSuitcase, faCircleCheck, faCircleXmark, faDownload, faFilePdf, faPenToSquare } from '@fortawesome/free-solid-svg-icons'
import { useState } from "react";


import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    CircularProgress
} from '@mui/material';
import { formatCsvDataExport, formatExcelData } from "../../utils/formats";

import dayjs from 'dayjs';
import { formatBrDate } from "../../utils/formats";

import ExcelUpdater from "../../components/global/excel-test";
import { Switch } from '@mui/material';

import { djangoApi } from "../../utils/axios/axios.utils";

import { useDispatch } from "react-redux";
import { updateSellersKitsDeliveredInfo, updateSellersKitsDeliveredDate } from "../../store/products/products.action";

import toast from "react-hot-toast";

import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { comissionHandler } from "../../utils/comission-handler";


dayjs.locale("pt-br");


const TablesKitPage = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const dispatch = useDispatch();

    const { sellersData: { kits }, setOpen, setOpenNotaPromi, handlerEditProduct } = props;
    const { sellersData } = props

    const [loadingStates, setLoadingStates] = useState({}); // Tracks loading state for each kit
    const [loadingStatesDatePick, setLoadingStatesDatePick] = useState({}); // Tracks loading state for each kit


    const formatNumber = (data) => {
        return data.toLocaleString(
            "pt-br",
            {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }
        )
    }

    const [page, setPage] = useState(0);
    const rowsPerPage = 11;

    // Sort kits in descending order, and then paginate
    const sortedKits = kits.sort((a, b) => b.kit_number - a.kit_number);
    const paginatedKits = sortedKits.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };


    const handlerPdfFile = (data) => {
        const objToAdd = {
            sellers: sellersData,
            data: data
        }
        setOpenNotaPromi(objToAdd)
    }

    const handlerOpenProducts = (data) => {
        setOpen(data)
    }

    const capitalizeFirstAndLastWords = (input) => {
        const words = input.trim().split(" ");
        if (words.length === 1) {
            return words[0].charAt(0).toUpperCase() + words[0].slice(1).toLowerCase();
        }

        const firstWord = words[0].charAt(0).toUpperCase() + words[0].slice(1).toLowerCase();
        const lastWord = words[words.length - 1].charAt(0).toUpperCase() + words[words.length - 1].slice(1).toLowerCase();

        return `${firstWord}_${lastWord}`;
    }

    const transformDate = (inputDate) => {
        const [year, month, day] = inputDate.split("-");
        return `${day}-${month}-${year}`;
    }

    const handleIsDelivered = async (kitData) => {
        setLoadingStates((prevState) => ({
            ...prevState,
            [kitData.kit_number]: true,
        }));
        try {
            await djangoApi
                .post("products/kits_active/update_is_delivered_kit/", kitData, {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                })
                .then((res) => {
                    console.log('res: ', res)
                    const { status } = res;

                    setLoadingStates((prevState) => ({
                        ...prevState,
                        [kitData.kit_number]: false,
                    }));
                    if (status === 201) {
                        toast.success(
                            `Status Atualizado com Sucesso!!`,
                            {
                                position: 'top-right'
                            }
                        );
                        dispatch(updateSellersKitsDeliveredInfo(kitData, sellersData, res?.data?.is_delivered))
                    }
                });
        } catch (err) {
            console.log("Erro ao alterar as aplicações", err);
            window.alert(err);
            setLoadingStates((prevState) => ({
                ...prevState,
                [kitData.kit_number]: false,
            }));
        } finally {
            // pass
            setLoadingStates((prevState) => ({
                ...prevState,
                [kitData.kit_number]: false,
            }));
        }
    };

    const handleChangePickDate = async (kitData, datePick) => {
        const formattedDate = datePick.format("YYYY-MM-DD"); // Convert to backend format

        setLoadingStatesDatePick((prevState) => ({
            ...prevState,
            [kitData.kit_number]: true,
        }));

        const params = {
            ...kitData,
            delivered_date: formattedDate
        }
        try {
            await djangoApi
                .post("products/kits_active/update_delivered_date_kit/", params, {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                })
                .then((res) => {
                    console.log('res: ', res)
                    const { status } = res;

                    setLoadingStatesDatePick((prevState) => ({
                        ...prevState,
                        [kitData.kit_number]: false,
                    }));
                    if (status === 201) {
                        toast.success(
                            `Data Entrega Alterada com Sucesso!!`,
                            {
                                position: 'top-right'
                            }
                        );
                        dispatch(updateSellersKitsDeliveredDate(kitData, sellersData, res?.data?.delivered_date))
                    }
                });
        } catch (err) {
            console.log("Erro ao alterar as aplicações", err);
            window.alert(err);
            setLoadingStatesDatePick((prevState) => ({
                ...prevState,
                [kitData.kit_number]: false,
            }));
        } finally {
            // pass
            setLoadingStatesDatePick((prevState) => ({
                ...prevState,
                [kitData.kit_number]: false,
            }));
        }
    }


    const handlerNfPrint = (kit) => {
        console.log('kit here: ', kit);
        // Assuming kit has a property `nf_url` with the Nota Fiscal URL
        if (kit && kit?.nota_fiscal_url) {
            window.open(kit.nota_fiscal_url, '_blank');
        } else {
            console.warn("No valid URL found for this kit.");
        }
    };





    return (<Box>
        <TableContainer component={Paper} elevation={6}>
            <Table
            >
                <TableHead>
                    <TableRow
                        sx={{
                            backgroundColor: colors.grey[900]

                        }}
                    >
                        <TableCell sx={{ fontSize: '14px !important', textAlign: 'center !important', fontWeight: 'bold !important' }}>Kit</TableCell>
                        <TableCell sx={{ fontSize: '14px !important', textAlign: 'center !important', fontWeight: 'bold !important' }}>Nº</TableCell>
                        <TableCell sx={{ fontSize: '14px !important', textAlign: 'center !important', fontWeight: 'bold !important' }}>Emissão</TableCell>
                        <TableCell sx={{ fontSize: '14px !important', textAlign: 'center !important', fontWeight: 'bold !important' }}>Devolvido</TableCell>
                        <TableCell sx={{ fontSize: '14px !important', textAlign: 'center !important', fontWeight: 'bold !important' }}>Ativo</TableCell>
                        <TableCell sx={{ fontSize: '14px !important', textAlign: 'center !important', fontWeight: 'bold !important' }}>Data Prev. Pgto</TableCell>
                        <TableCell sx={{ fontSize: '14px !important', textAlign: 'center !important', fontWeight: 'bold !important' }}>Valor Total</TableCell>
                        <TableCell sx={{ fontSize: '14px !important', textAlign: 'center !important', fontWeight: 'bold !important' }}>Total Vendas</TableCell>
                        <TableCell sx={{ fontSize: '14px !important', textAlign: 'center !important', fontWeight: 'bold !important' }}>% Vendido</TableCell>
                        <TableCell sx={{ fontSize: '14px !important', textAlign: 'center !important', fontWeight: 'bold !important' }}>Comissão</TableCell>
                        <TableCell sx={{ fontSize: '14px !important', textAlign: 'center !important', fontWeight: 'bold !important' }}>Entregue</TableCell>
                        <TableCell sx={{ fontSize: '14px !important', textAlign: 'center !important', fontWeight: 'bold !important' }}>Data Entrega</TableCell>
                        <TableCell sx={{ fontSize: '14px !important', textAlign: 'center !important', fontWeight: 'bold !important' }}>Pago</TableCell>
                        <TableCell sx={{ fontSize: '14px !important', textAlign: 'center !important', fontWeight: 'bold !important' }}>NF</TableCell>
                        <TableCell sx={{ fontSize: '14px !important', textAlign: 'center !important', fontWeight: 'bold !important' }}>
                            <FontAwesomeIcon icon={faDownload} color={colors.greenAccent[600]} />
                        </TableCell>
                        <TableCell sx={{ fontSize: '14px !important', textAlign: 'center !important', fontWeight: 'bold !important' }}>
                            Inadimplente
                        </TableCell>
                        <TableCell sx={{ fontSize: '14px !important', textAlign: 'center !important', fontWeight: 'bold !important' }}>
                            Editar
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {paginatedKits.map((kit, index) => {
                        const totalValue = kit.kit_products.reduce((acc, curr) => acc += (curr.sell_price * curr.quantity), 0)
                        const csvFileName = `${capitalizeFirstAndLastWords(sellersData?.user?.nome)}_${transformDate(kit.pay_date)}`
                        const csvData = formatCsvDataExport(kit?.kit_products)
                        const excelDataFormat = formatExcelData(csvData)
                        const totalSold = kit?.kit_products.reduce((acc, curr) => acc += ((curr.quantity - curr.quantity_returned) * curr.sell_price), 0)
                        const kitPayDate = dayjs(kit.pay_date, 'YYYY-MM-DD').startOf('day').format('DD/MM/YYYY');

                        // console.log('kit:: ', kit)

                        const commissionBase = kit.kit_products.reduce((acc, curr) => {
                            const soldQty = Number(curr.quantity || 0) - Number(curr.quantity_returned || 0);
                            const isPackage = curr.content_type === "embalagem";

                            if (isPackage || soldQty <= 0) return acc;

                            return acc + soldQty * Number(curr.sell_price || 0);
                        }, 0);

                        // se na tabela você ainda não tiver vouchers por kit:
                        const totalValueVouchers = 0;

                        const commissionValue = comissionHandler(commissionBase - totalValueVouchers);

                        return (

                            <TableRow key={kit.kit_number}
                                sx={{
                                    backgroundColor: index % 2 === 0 ? colors.grey[700] : colors.grey[600],
                                    '& .MuiTableCell-root': {
                                        fontSize: '12px !important',
                                        textAlign: 'center',
                                        padding: '1px'
                                    },
                                    '&:hover td': {
                                        backgroundColor: 'grey'
                                    },
                                }}
                            >
                                <TableCell>
                                    <Button
                                        onClick={() => handlerOpenProducts(kit)}
                                        sx={{
                                            minWidth: '30px',  // Sets a minimum width for the button
                                            height: '30px',     // Sets a fixed height for the button
                                            padding: '10px',    // Adjusts padding for larger clickable area
                                            color: !kit.is_delivered_to ? colors.yellow[400] : kit.is_active ? colors.greenAccent[600] : colors.primary[200],
                                            fontSize: '14px',   // Increases font size
                                            borderRadius: '4px', // Optional: Adjust border radius
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            size="lg"
                                            icon={faSuitcase}
                                        />
                                    </Button>
                                </TableCell>
                                <TableCell>{kit.kit_number}</TableCell>
                                <TableCell>{kit.created_at ? formatBrDate(kit.created_at) : 'N/A'}</TableCell>
                                <TableCell>
                                    {kit.returned_at ? formatBrDate(kit.returned_at) : 'N/A'}
                                </TableCell>
                                <TableCell>
                                    {kit.is_active ?
                                        <FontAwesomeIcon icon={faCircleCheck} color={colors.greenAccent[600]} />
                                        :
                                        <FontAwesomeIcon icon={faCircleXmark} color={colors.redAccent[500]} />
                                    }</TableCell>
                                <TableCell>{kitPayDate}</TableCell>
                                <TableCell>R$ {formatNumber(totalValue)}</TableCell>
                                <TableCell>{!kit.is_active ? `R$ ${formatNumber(totalSold)}` : '-'}</TableCell>
                                <TableCell>{!kit.is_active ? `${formatNumber((totalSold / totalValue) * 100)} %` : '-'}</TableCell>
                                <TableCell>{!kit.is_active ? `R$ ${formatNumber(commissionValue)}` : '-'}</TableCell>
                                <TableCell>
                                    {
                                        loadingStates[kit.kit_number] ?
                                            <CircularProgress size={24} color="success" />
                                            :
                                            <Switch
                                                checked={kit.is_delivered_to}
                                                onChange={() => handleIsDelivered(kit)} // Pass kit ID and current value
                                                color="success" // MUI success color for "on" state
                                            />

                                    }
                                </TableCell>
                                <TableCell>
                                    {
                                        loadingStatesDatePick[kit.kit_number] ?
                                            <CircularProgress size={24} color="success" />
                                            :

                                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
                                                <DatePicker
                                                    value={kit?.delivered_date ? dayjs(kit.delivered_date, "YYYY-MM-DD") : null}
                                                    onChange={(newDate) => handleChangePickDate(kit, newDate)} // Pass kit and selectedDate
                                                    sx={{
                                                        width: 130,
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                border: "none", // Removes the border
                                                            },
                                                        },
                                                    }} // Adjust width as needed
                                                    renderInput={({ inputRef, inputProps, InputProps }) => (
                                                        <TextField
                                                            variant="outlined"
                                                            inputRef={inputRef}
                                                            InputProps={{
                                                                ...InputProps,
                                                                readOnly: true, // Make the input field read-only
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <IconButton onClick={() => inputRef.current?.focus()}>
                                                                            <CalendarTodayIcon />
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                            inputProps={{
                                                                ...inputProps,
                                                                value: kit?.delivered_date
                                                                    ? dayjs(kit.delivered_date, "YYYY-MM-DD").format("DD/MM/YYYY")
                                                                    : "N/A", // Display N/A if no date exists
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </LocalizationProvider>
                                    }
                                </TableCell>
                                <TableCell>
                                    {kit.is_paid ?
                                        <FontAwesomeIcon icon={faCircleCheck} color={colors.greenAccent[600]} />
                                        :
                                        <FontAwesomeIcon icon={faCircleXmark} color={colors.redAccent[500]} />
                                    }</TableCell>
                                <TableCell>
                                    <Button
                                        disabled={!kit?.nota_fiscal_url}
                                        onClick={() => handlerNfPrint(kit)}
                                        sx={{
                                            minWidth: '40px',
                                            height: '40px',
                                            padding: '10px',
                                            color: colors.primary[100],
                                            fontSize: '16px',
                                            borderRadius: '4px',
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            size="lg"
                                            icon={faFilePdf}
                                        />
                                    </Button>
                                </TableCell>
                                <TableCell
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        gap: '10px',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <ExcelUpdater
                                        data={excelDataFormat}
                                        fileName={csvFileName}
                                        kitNumber={`KIT ${kit.kit_number}`}
                                        sellerName={sellersData.user.nome}
                                        dataEntrega={kit?.created_at}
                                        dataAcerto={kit?.pay_date}
                                    />
                                    {/* <Button
                                        onClick={() => handlerExcelFile(kit)}
                                        sx={{
                                            minWidth: '40px',  // Sets a minimum width for the button
                                            height: '40px',     // Sets a fixed height for the button
                                            padding: '10px',    // Adjusts padding for larger clickable area
                                            color: colors.greenAccent[600],
                                            fontSize: '16px',   // Increases font size
                                            borderRadius: '4px', // Optional: Adjust border radius
                                        }}
                                    >
                                        <ExcelExport 
                                        data={excelDataFormat} 
                                        fileName={csvFileName}
                                        kitNumber={`KIT ${kit.kit_number}`}
                                        sellerName={sellersData.user.nome}
                                        dataEntrega={kit?.created_at}
                                        dataAcerto={kit?.pay_date}
                                        />
                                        <CSVLink data={csvData} separator={";"} filename={`${csvFileName}.csv`}
                                            style={{ color: 'inherit', textDecoration: 'none' }} // Ensure it inherits color
                                        >
                                            <FontAwesomeIcon
                                                size="lg"
                                                icon={faFileExcel}
                                                color={colors.greenAccent[600]}
                                            />
                                        </CSVLink>
                                    </Button> */}
                                    <Button
                                        onClick={() => handlerPdfFile(kit)}
                                        sx={{
                                            minWidth: '40px',
                                            height: '40px',
                                            padding: '10px',
                                            color: colors.primary[200],
                                            fontSize: '16px',
                                            borderRadius: '4px',
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            size="lg"
                                            icon={faFilePdf}
                                        />
                                    </Button>
                                </TableCell>
                                <TableCell>
                                    {kit.failure_to_pay === true ? (
                                        <FontAwesomeIcon icon={faTriangleExclamation} color="goldenrod" style={{ fontSize: "1.3rem" }} />
                                    ) : (
                                        <FontAwesomeIcon icon={faCircleCheck} color={colors.greenAccent[600]} />
                                    )}
                                </TableCell>
                                <TableCell>

                                    <Button
                                        onClick={() => handlerEditProduct(kit)}
                                        sx={{
                                            minWidth: '40px',  // Sets a minimum width for the button
                                            height: '40px',     // Sets a fixed height for the button
                                            padding: '10px',    // Adjusts padding for larger clickable area
                                            color: colors.yellow[600],
                                            fontSize: '16px',   // Increases font size
                                            borderRadius: '4px', // Optional: Adjust border radius
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            size="lg"
                                            icon={faPenToSquare}
                                        />
                                    </Button>

                                </TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
            <TablePagination
                sx={{
                    backgroundColor: colors.grey[900],

                    '& .MuiToolbar-root .MuiTablePagination-toolbar': {
                        maxHeight: '20px !importatn'
                    }
                }}
                rowsPerPageOptions={[7]}
                component="div"
                count={kits.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
            />
        </TableContainer>
    </Box>);
}

export default TablesKitPage;